export { getAppVersionLabel } from "#get-app-version-label";
